
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  $(document).ready(function() {
    if (isMobile) {
      console.log('Mobile device detected (User Agent method)');
      // Mobile specific code
      $('.wt-video-hosted--desktop video').remove();
    } else {
      console.log('Desktop device detected (User Agent method)');
      // Desktop specific code
    }
  });
